// extracted by mini-css-extract-plugin
export default {"ratingBoxContainer":"RatingBox_ratingBoxContainer__Fi-M5","ratingBox":"RatingBox_ratingBox__Dp+Fo","label":"RatingBox_label__13Fc3"};